<template>
    <v-row>
        <v-col>
            <v-menu
                    v-model="fromDialogIsOpen"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                            v-model="fromDateAsLocalString"
                            :label="$tc('From')"
                            prepend-icon="calendar_today"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :disabled="disabled"
                    ></v-text-field>
                </template>
                <v-date-picker
                        v-model="selectedFromDateForVModel"
                        :first-day-of-week="firstDayOfWeek"
                        :locale="this.$i18n.locale"
                        :max="selectedToDateForVModel"
                        @input="fromDialogIsOpen = false"
                ></v-date-picker>
            </v-menu>
        </v-col>

        <v-col>
            <v-menu
                    v-model="toDialogIsOpen"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                            v-model="toDateAsLocalString"
                            :label="$tc('To')"
                            prepend-icon="calendar_today"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :disabled="disabled"
                    ></v-text-field>
                </template>
                <v-date-picker
                        v-model="selectedToDateForVModel"
                        :first-day-of-week="firstDayOfWeek"
                        :locale="this.$i18n.locale"
                        :min="selectedFromDateForVModel"
                        @input="toDialogIsOpen = false"
                ></v-date-picker>
            </v-menu>
        </v-col>
    </v-row>
</template>
<script>
    import {mapGetters, mapMutations, mapState} from "vuex";

    export default {
        name: 'FromToDateFilter',
        props: ['disabled'],
        data: function () {
            return {
                fromDialogIsOpen: false,
                toDialogIsOpen: false,
            }
        },
        methods: {
            ...mapMutations({
                setSelectedFromDate: 'common/setSelectedFromDate',
                setSelectedToDate: 'common/setSelectedToDate',
            }),
        },
        computed: {
            ...mapState('common', [
                'selectedFromDate',
                'selectedToDate',
            ]),
            ...mapGetters('common', [
               'firstDayOfWeek'
            ]),
            // We must have a local property with a getter and setter
            // since Vuex does not allow setting state directly (mutations must be used)
            selectedFromDateForVModel: {
                get: function () {
                    return this.selectedFromDate;
                },
                set: function (newValue) {
                    this.setSelectedFromDate(newValue);
                }
            },
            selectedToDateForVModel: {
                get: function () {
                    return this.selectedToDate;
                },
                set: function (newValue) {
                    this.setSelectedToDate(newValue);
                }
            },
            fromDateAsLocalString: {
                get: function () {
                    return new Date(this.selectedFromDate).toLocaleDateString();
                },
            },
            toDateAsLocalString: {
                get: function () {
                    return new Date(this.selectedToDate).toLocaleDateString();
                },
            },
        },
    }
</script>
